import React, { useState } from 'react';
import { Percent, GitMerge, Loader2, LogOut } from 'lucide-react';
import { Logo } from './Logo';
import { MatchesModal } from './MatchesModal';
interface TopMetricsProps {
  onSignOut?: () => void;
}
export const TopMetrics = ({
  onSignOut
}: TopMetricsProps) => {
  const [showMatchesModal, setShowMatchesModal] = useState(false);
  const [matchesCount, setMatchesCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const handleFindMatches = () => {
    setIsLoading(true);
    // Simulate algorithm processing time
    setTimeout(() => {
      setMatchesCount(6); // Update to show 6 high-compatibility matches
      setIsLoading(false);
      setShowMatchesModal(true);
    }, 2500); // 2.5 second delay to simulate processing
  };
  const handleSignOut = () => {
    localStorage.removeItem('bridge_auth');
    if (onSignOut) {
      onSignOut();
    } else {
      // Fallback if onSignOut prop is not provided
      window.location.reload();
    }
  };
  return <div className="flex h-14 px-4 bg-[#111] border-b border-[#222] text-sm justify-between" data-id="element-572">
      <div className="flex items-center" data-id="element-573">
        <div className="flex items-center mr-8" data-id="element-574">
          <Logo data-id="element-575" />
        </div>
        <div className="flex items-center space-x-8" data-id="element-576">
          <div className="flex items-center text-white" data-id="element-577">
            <div className="flex items-center gap-2 px-3 py-1.5 bg-[#1a1a1a] rounded" data-id="element-578">
              <GitMerge size={16} className="text-purple-400" data-id="element-579" />
              <span className="font-semibold" data-id="element-580">
                High-compatibility matches found:
              </span>
              <span className="text-purple-400 font-mono" data-id="element-581">{matchesCount}</span>
              <button onClick={handleFindMatches} disabled={isLoading} className={`ml-2 px-2 py-0.5 ${isLoading ? 'bg-purple-700 cursor-not-allowed' : 'bg-purple-500 hover:bg-purple-600'} rounded text-xs font-medium transition-colors flex items-center`} data-id="element-582">
                {isLoading ? <>
                    <Loader2 size={12} className="mr-1 animate-spin" data-id="element-583" />
                    Analyzing...
                  </> : 'Find Matches'}
              </button>
            </div>
          </div>
          <div className="flex items-center text-white" data-id="element-584">
            <div className="flex items-center gap-2 px-3 py-1.5 bg-[#1a1a1a] rounded" data-id="element-585">
              <Percent size={16} className="text-yellow-400" data-id="element-586" />
              <span className="font-semibold" data-id="element-587">Pattern confidence:</span>
              <span className="text-yellow-400 font-mono" data-id="element-588">null%</span>
            </div>
          </div>
        </div>
      </div>
      {/* Sign out button */}
      <div className="flex items-center" data-id="element-589">
        <button onClick={handleSignOut} className="flex items-center gap-1.5 px-3 py-1.5 bg-[#1a1a1a] hover:bg-[#333] rounded text-gray-300 hover:text-white transition-colors" data-id="element-590">
          <LogOut size={14} data-id="element-591" />
          <span className="text-xs" data-id="element-592">Sign Out</span>
        </button>
      </div>
      {showMatchesModal && <MatchesModal onClose={() => setShowMatchesModal(false)} data-id="element-593" />}
    </div>;
};